import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

export default function CAManifestGrid(props) {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const overlayLoadingTemplate = '<div class="m-t-md"><div class="loader"></div></div>';
  const overlayNoRecordsTemplate = '<span class="ag-overlay-loading-center">No Records Found</span>';
  const defaultColDef = {
    headerClass: "profile-grid-group-header",
  };

  const columnDefs = [
    {
      headerName: "Year",
      field: "SHIP_YEAR",
      sort: "dsc",
      filter: "agDateColumnFilter",
      width: 86,
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/reports/manifest?epaId=${params.data.EPA_ID}&shipYear=${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      headerName: "Generator",
      marryChildren: true,
      headerClass: "profile-grid-group-header",
      children: [
        {
          headerName: "Count",
          field: "GEN_COUNTS",
          filter: "agNumberColumnFilter",
          width: 88,
          cellRenderer: function (params) {
            if (params.value != null) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.EPA_ID}&shipYear=${params.data.SHIP_YEAR}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Tons",
          field: "GEN_TONS",
          filter: "agNumberColumnFilter",
          //width: 130,
          cellRenderer: function (params) {
            if (params.value != null) {
              return (
                `<a href="/reports/hazardous-waste-summary?epaId=${params.data.EPA_ID}&shipYear=${params.data.SHIP_YEAR}&siteType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
      ],
    },
    {
      headerName: "Transporter",
      marryChildren: true,
      headerClass: "profile-grid-group-header",
      children: [
        {
          headerName: "Count",
          field: "TRANS_COUNTS",
          filter: "agNumberColumnFilter",
          width: 88,
          cellRenderer: function (params) {
            if (params.value != null) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.EPA_ID}&shipYear=${params.data.SHIP_YEAR}&entityType=Transporter" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Tons",
          field: "TRANS_TONS",
          filter: "agNumberColumnFilter",
          //width: 130,
          cellRenderer: function (params) {
            if (params.value != null) {
              return (
                `<a href="/reports/hazardous-waste-summary?epaId=${params.data.EPA_ID}&shipYear=${params.data.SHIP_YEAR}&siteType=Transporter" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
      ],
    },
    {
      headerName: "TSDF",
      marryChildren: true,
      headerClass: "profile-grid-group-header",
      children: [
        {
          headerName: "Count",
          field: "TSDF_COUNTS",
          filter: "agNumberColumnFilter",
          width: 88,
          cellRenderer: function (params) {
            if (params.value != null) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.EPA_ID}&shipYear=${params.data.SHIP_YEAR}&entityType=TSDF" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Tons",
          field: "TSDF_TONS",
          filter: "agNumberColumnFilter",
          //width: 130,
          cellRenderer: function (params) {
            if (params.value != null) {
              return (
                `<a href="/reports/hazardous-waste-summary?epaId=${params.data.EPA_ID}&shipYear=${params.data.SHIP_YEAR}&siteType=TSDF" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
      ],
    },
  ];

  const onGridReady = (params) => {
    params.columnApi.autoSizeAllColumns();
    params.api.sizeColumnsToFit();
    params.api.hideOverlay();
    params.api.refreshCells();
    if (props.isFetching) {
      params.api.showLoadingOverlay();
    } else if (
      !params.api.isFetching &&
      params.api.manifests &&
      params.api.manifests.length < 1
    ) {
      params.api.showNoRowsOverlay();
    } else {
      params.api.hideOverlay();
    }
    if (props.csvOnly === true) {
      params.api.setDomLayout("0");
    } else {
      params.api.setDomLayout("autoHeight");
    }

    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const onBtPrinterFriendly = () => {
    if (gridApi && gridColumnApi) {
      if (props.csvOnly === true) {
        gridApi.setDomLayout("0");
      } else {
        gridApi.setDomLayout("print");
        gridApi.sizeColumnsToFit();
        gridColumnApi.autoSizeAllColumns();
      }
    }
  };

  const onBtNormal = () => {
    if (gridApi) {
      if (props.csvOnly === true) {
        gridApi.setDomLayout("0");
      } else {
        gridApi.setDomLayout("autoHeight");
        gridApi.sizeColumnsToFit();
      }
    }
  };

  window.addEventListener("beforeprint", () => onBtPrinterFriendly());
  window.addEventListener("afterprint", () => onBtNormal());

  const getRowStyle = (params) => {
    if (params.node.rowIndex % 2 === 1) {
      return { "background-color": "#eaf3f9" };
    }
  };

  const csvExport = () => {
    var params = {
      columnGroups: true,
      fileName: `${props.EPA_ID}_CAManifestCountsTons.csv`,
      customHeader: [
        [],
        [
          {
            data: {
              value: `${props.EPA_ID} - California Manifest Counts and Total Tonnage`,
              type: "String",
            },
          },
        ],
        [
          {
            data: {
              value: `The Department of Toxic Substances Control (DTSC) takes every precaution to ensure the accuracy of data in the Hazardous Waste Tracking System (HWTS).`,
              type: "String",
            },
          },
        ],
        [
          {
            data: {
              value: `However, because of the large number of manifests handled, inaccuracies in the submitted data, limitations of the manifest system and the technical limitations of the database, DTSC cannot guarantee that the data accurately reflect what was actually transported or produced.`,
              type: "String",
            },
          },
        ],
        [],
      ],
    };
    gridApi.exportDataAsCsv(params);
  };

  return (
    <div>
      <div className="manifest-grid-title">
        Manifest Counts and Total Tonnage
        </div>
      <div className="manifest-ag-grid center-block table ag-theme-balham">
        {props.data.length > 0 ? (
          <div className="ca-manifest-counts-csv csv-btn">
            <button
              className="btn btn-standout"
              style={{
                fontSize: "0.85rem",
                padding: "0.3rem 0.5rem",
              }}
              onClick={() => csvExport()}
            >
              Export CSV
              </button>
          </div>
        ) : null}
        <div className="" style={{ textAlign: "center!important" }}>
          <AgGridReact
            onGridReady={onGridReady}
            defaultColDef={defaultColDef}
            columnDefs={columnDefs}
            rowData={props.data}
            domLayout={"autoHeight"}
            rowSelection={"multiple"}
            multiSortKey={true}
            getRowStyle={getRowStyle}
            rowClass={"ag-grid-selectable"}
            overlayLoadingTemplate={overlayLoadingTemplate}
            overlayNoRowsTemplate={overlayNoRecordsTemplate}
          />
        </div>
      </div>
    </div>
  );
}
